//====================================================
//  Function: Category Create
//====================================================
var categoryGroup = $('.js-category-group')
var arrayResultSideCategory = []

function componentCategoryCreate() {
  if ($('.js-category-group').length) {
    categoryGroup = $('.js-category-group')

    $('.js-select-option').change(function () {
      var checkbox = $(this)
      // var checkboxValue = checkbox.val()
      // var checkboxCode = checkbox.closest('.js-select-item').data('code')
      $('div').removeClass('is-clicked')
      $('.code-box__item').removeClass('is-clicked')
      // clearTimeout(myTimeoutCode);
      addToCategoryResultCode()
      // rebuildTopCategoryResult()
    })

    $(document).on(
      'keyup',
      '.js-select-input, .js-select-input-main, .js-select-input-another',
      function () {
        addToCategoryResultCode()
      },
    )
  }
}

function addToCategoryResultCode() {
  var arrayResultCategory = []
  var arrayResultCategoryItems = []
  var mainItem = false
  var anotherItem = true

  $('.js-select-item').each(function () {
    var item = $(this)

    $('.js-select-input-another').each(function () {
      input = $(this)
      if (input.val().length > 0) {
        // if ($('.js-select-input-main').val().length > 0) {
        //   $('.js-select-input-main').val('')
        // }

        // var templateBoxItem = `
        // 	<div class="code-box__item">
        // 	<strong>var <span class="js-result-type">topCategoryMenuItem</span> = <span class="js-result-value txt-green">${input.val()};</span></strong></div>
        // `
        var inputValue = input.val()

        arrayResultCategoryItems.push('"' + inputValue + '"')
        // anotherItem = true
      } else {
        // anotherItem = false
      }
    })

    // var checkInputAnother = checkAnother()

    if (!anotherItem) {
      // if ($('.js-select-input-main').val().length > 0) {
      //   var inputValue = $('.js-select-input-main').val()
      //   var templateBoxItem = `
      // 		<div class="code-box__item">
      // 		<strong>var <span class="js-result-type">topCategoryMenuItem</span> = <span class="js-result-value txt-green">${inputValue};</span></strong></div>
      // 	`
      //   arrayResultCategory.push(templateBoxItem)
      // }
    } else {
      if (arrayResultCategoryItems.join().length > 0) {
        var templateBoxItem = `
					<div class="code-box__item">
					<strong>var <span class="js-result-type">topCategoryMenuItem</span> = <span class="js-result-value txt-green">[${arrayResultCategoryItems.join()}];</span></strong></div>
				`
        arrayResultCategory.push(templateBoxItem)
      }
    }

    item.find('.js-select-input').each(function () {
      var input = $(this)
      var inputParent = input.closest('.js-stats')
      var inputValue = input.val()
      var inputCode = inputParent.data('code')
      var inputQuotes = inputParent.data('quotes')
      var inputType = inputParent.data('type')

      if (inputQuotes == true) {
        inputValue = '"' + inputValue + '"'
      }

      if (inputType == 'number') {
        inputValue = parseInt(inputValue)
      } else {
        inputValue = '"' + inputValue + '"'
      }

      var templateBoxItem = `
					<div class="code-box__item">
					<strong>var <span class="js-result-type">${inputCode}</span> = <span class="js-result-value txt-green">${inputValue};</span></strong></div>
			`
      arrayResultCategory.push(templateBoxItem)
    })

    item.find('.js-stats-checkbox').each(function () {
      var element = $(this)
      var checkedCheckbox = element.find('.js-select-option')
      var checkboxValue = checkedCheckbox.val()
      var clickedClass = ''
      var checkboxCode = element.data('code')
      var checkboxQuotes = element.data('quotes')

      if (checkedCheckbox.is(':checked')) {
        checkboxValue = true
      } else {
        checkboxValue = false
      }

      if (checkboxQuotes == true) {
        checkboxValue = '"' + checkboxValue + '"'
      }

      if (element.hasClass('is-clicked')) {
        clickedClass = 'is-clicked'
      }

      // if (checkboxValue === 'false' || checkboxValue === '"left"') {
      //   return false
      // }

      var templateBoxItem = `
			<div class="code-box__item ${clickedClass}">
			<strong>var <span class="js-result-type">${checkboxCode}</span> = <span class="js-result-value txt-green">${checkboxValue};</span></strong></div>
			`
      arrayResultCategory.push(templateBoxItem)
      arrayResultSideCategory.push(templateBoxItem)
      element
        .find('.js-label-value')
        .html('var ' + checkboxCode + ' = <span> ' + checkboxValue + '</span>')
    })
  })

  $('.js-code-result').empty()
  $('.js-code-result').append(arrayResultCategory)
}

// function checkAnother() {
//   $('.js-select-input-another').each(function () {
//     input = $(this)
//     if (input.val().length > 0) {
//       return false
//     }
//     return true
//   })
// }
